import https from "../../axios";
import { RegisterPayload } from "../../db/action/register";
import { BaseResponse } from "../../db/response";
import normalizeBaseResponse from "../../utils/responseHandler";
import errorHandler from "../../utils/errorHandler";

export interface SignUpResponse extends BaseResponse {
  data?: {
    message: string;
    userId: string;
    accountId: string;
    accountName?: string;
    role: string;
  };
}

export const doSignUp = async (
  params: RegisterPayload,
): Promise<SignUpResponse> => {
  try {
    const response = await https.post("/sign-up", params);
    return {
      ...normalizeBaseResponse(response.data),
      data: response.data?.data,
    };
  } catch (error) {
    return errorHandler(error);
  }
};
